/**
 * Resolves where hosted surveys live, so links work in BOTH local dev and
 * production. Surveys are served from the public `/s` router on the same forms
 * surface (see api `surveys-public.routes.ts`).
 *
 *   - Local dev: the Vite dev server proxies /s to the API, so we use the
 *     current origin (e.g. http://localhost:3001). Links resolve.
 *   - Production: served from the canonical forms host, override per-env with
 *     VITE_FORMS_HOST.
 *
 * Mirrors `features/forms/hostedUrl.ts` — surveys reuse the forms host.
 */
import { formsBase } from '../forms/hostedUrl';

/** Public hosted URL for a published ANONYMOUS survey slug. */
export function hostedSurveyUrl(slug: string): string {
  return `${formsBase().origin}/s/${slug}`;
}

/**
 * Hosted URL for an identified (tokenised) survey link. The token is issued
 * server-side per recipient; this only formats the resume/open URL shape so the
 * builder can show recruiters what an identified link looks like.
 */
export function tokenisedSurveyUrl(token: string): string {
  return `${formsBase().origin}/s/c/${token}`;
}
